import * as React from "react";
import { RefObject } from "react";
import Treatment from "../commons/model/treatment/Treatment";

interface TreatmentOptionProps {
  treatment: Treatment;
  onRemove: (treatment: Treatment) => any;
}

export default class TreatmentOption extends React.Component<TreatmentOptionProps> {
  private readonly domElement: RefObject<HTMLElement>;

  constructor(props: TreatmentOptionProps) {
    super(props);
    this.domElement = React.createRef();
    this.removeOptionHandler = this.removeOptionHandler.bind(this);
  }

  render() {
    return (
      <div key={this.props.treatment.uid} className="label primary">
        <span>{this.props.treatment.name}</span>
        <i className="action ic_close clickable" ref={this.domElement} />
      </div>
    );
  }

  // sjahan 26/07/19: We use a DOM event listener and not a React one to prevent interaction with the rest of the DOM and the vertical drop-downs.
  componentDidMount() {
    this.domElement.current.addEventListener("click", this.removeOptionHandler);
  }

  componentDidUpdate() {
    this.domElement.current.addEventListener("click", this.removeOptionHandler);
  }

  componentWillUnmount() {
    this.domElement.current.removeEventListener("click", this.removeOptionHandler);
  }

  private removeOptionHandler(e: Event) {
    e.stopPropagation();
    this.props.onRemove(this.props.treatment);
  }
}
